import React from 'react';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { SiTrackPage } from '../../../../components/si-track-page';

import { Grid, Paper } from '@mui/material';
import { WorkOrderLogColumns } from './work-order-log-columns';
import { useLoadData } from '../../../../hooks/useLoadData';
import { workorderReportApiKeyStore } from '../../../../api/workorder-report-api-key-store';
import { ApiResponse } from '../../../../models/api-response';
import { useParams } from 'react-router-dom';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '10px' },
};

const WorkOrderLogList = () => {
  const { id } = useParams();
  const { data, isLoading, isFetching, refetch } = useLoadData<ApiResponse<any[]>>(
    workorderReportApiKeyStore.getWorkOrderLog(Number(id))
  );

  return (
    <SiTrackGrid
      fileTitle='workorder_log'
      columns={WorkOrderLogColumns}
      dataItemKey="auditLogId"
      dataItems={data?.data}
      //   actionPermissions={{
      //     export: UserPermissionName.DOWNLOAD_GRID,
      //   }}
      isBusy={isLoading || isFetching}
    // customCell={(field) =>
    //   CustomGridCell({
    //     field,
    //   })
    // }
    />
  );
};

export default WorkOrderLogList;
